(function ($) {
    'use strict';

    $.widget("fd.control_editor", {
        options: {
            callback: function () { },
            iskeyup: false,
            iskeyupdelay: 250,
            maxlength: null,
            minlength: 0,
            parentid: null,
            allowcodeview: false, // Set to true to allow the HTML button to be shown
            inmodal: false // Set to true if editor is inside a modal
        },
        initial: function (value) {
            if (value === undefined) {
                return this.options.initial;
            }

            this.options.initial = value;
            this.element.data('initial', value).attr('data-initial', value);

            return this;
        },
        _create: function () {
            if (!this.options.parentid) {
                this.options.parentid = this.element.closest('[data-fd-parentid]').data('fd-parentid');
            }

            // Convert numeric options
            this.options.iskeyupdelay = Number(this.options.iskeyupdelay);
            this.options.minlength = Number(this.options.minlength);
            this.options.maxlength = this.options.maxlength ? Number(this.options.maxlength) : null;
            if (this.options.maxlength) {
                this.element.attr('maxlength', this.options.maxlength);
            }

            const viewToolbar = this.options.allowcodeview ? ['fullscreen', 'codeview', 'help'] : ['fullscreen', 'help'];
            this.element.summernote({
                codeviewFilter: true,
                codeviewIframeFilter: true,
                dialogsInBody: !this.options.inmodal,
                toolbar: [
                    ['style', ['style']],
                    ['font', ['bold', 'underline', 'clear']],
                    ['fontname', ['fontname']],
                    ['color', ['color']],
                    ['para', ['ul', 'ol', 'paragraph']],
                    ['table', ['table']],
                    ['insert', ['link', 'picture', 'video']],
                    ['view', viewToolbar]
                ]
            });

            this.initial(this.options.initial || this.element.val());
            this._setEvents();
        },
        _handleBlur: function (event) {
            const self = event.data;
            if (self.element.val() === self.options.initial) {
                return false;
            }
            self._handleSubmit(event);
            return true;
        },
        _handleFocus: function (event) {
            const self = event.data;
            self.initial(self.element.val());
        },
        _handleKeyup: function (event) {
            const self = event.data;
            if (self.options.iskeyup) {
                clearTimeout(self._keyupTimer);
                self._keyupTimer = setTimeout(function () {
                    self._handleSubmit(event);
                }, self.options.iskeyupdelay);
            }
        },
        _handleSubmit: function (event) {
            if (this._keyupTimer) {
                clearTimeout(this._keyupTimer);
                this._keyupTimer = null;
            }

            this.options.callback.call(this, { parentID: this.options.parentid, value: this.element.val().trim() }, event);
        },
        _keyupTimer: null,
        _setEvents: function () {
            this.element.off('blur.fdcontrol keyup.fdcontrol focus.fdcontrol')
                .on('blur.fdcontrol', null, this, this._handleBlur)
                .on('focus.fdcontrol', null, this, this._handleFocus)
                .on('keyup.fdcontrol', null, this, this._handleKeyup);
        },
        _setOption: function (key, value) {
            this.options[key] = value;
        },
        _destroy: function () {
            this.element.off('blur.fdcontrol keyup.fdcontrol focus.fdcontrol');
        }
    });
}(jQuery));